










import {Component, Vue} from 'vue-property-decorator';
import SupplierForm from '@/screens/dashboard/supplier/SupplierForm.vue';

@Component({
  components: {
    SupplierForm
  }
})
export default class NewSupplierScreen extends Vue {
}
